/** One candle in SVG coordinates (y grows downward, so a rising candle has c < o). */
export function Candle({ x, o, c, h, l, w = 10 }: { x: number; o: number; c: number; h: number; l: number; w?: number }) {
  const up = c <= o;
  const color = up ? "var(--profit)" : "var(--loss)";
  const top = Math.min(o, c), bot = Math.max(o, c);
  return (
    <g>
      <line x1={x} x2={x} y1={h} y2={l} stroke={color} strokeWidth={1.2} />
      <rect x={x - w / 2} y={top} width={w} height={Math.max(1.5, bot - top)} fill={color} rx={1} />
    </g>
  );
}
